<template>
  <div class="logisticsmodebox" v-if="porder_freight">
    <div class="huoyunTable">
      <div class="head tbc">
        <span>{{ $fanyi('发送方式') }}</span>
        <!--        -->

        <span>{{ $fanyi('物流单号') }}</span>
        <span>{{ $fanyi('计费重量') }}(kg)</span>
        <span>{{ $fanyi('乌克兰派送时间') }}</span>
        <span>{{ $fanyi('费用') }}(₴)</span>
      </div>

      <div class="body">
        <div class="opt tbc" v-for="(item, i) in $parent.wuliu" :key="i">
          <span>{{ item.foreign_express ? item.foreign_express : '-------'
          }}({{ item.type == 0 ? $fanyi('国际') : $fanyi('国内') }})</span>
          <span>{{
            item.foreign_express_no ? item.foreign_express_no : '-------'
          }}</span>
          <span>{{ item.weight ? item.weight : '-------' }}</span>
          <span>{{ item.created_at ? item.created_at : '-------' }}</span>
          <span>{{ item.price ? item.price : '-------' }}</span>
        </div>
      </div>
    </div>

    <div class="goodsTable">
      <div class="head">
        <!-- 箱号 -->
        <span class="sn">{{ $fanyi('箱号') }}</span>
        <!-- 实际重量 -->
        <span class="weight">{{ $fanyi('实际重量') }}(kg)</span>
        <!-- 长 -->
        <span class="long">{{ $fanyi('长') }}(cm)</span>
        <!-- 宽 -->
        <span class="wide">{{ $fanyi('宽') }}(cm)</span>
        <!-- 高 -->
        <span class="high">{{ $fanyi('高') }}(cm)</span>
        <!-- 体积 -->
        <span class="volume">{{ $fanyi('体积') }}(m³)</span>
        <!-- 物流单号 -->
        <!-- <span class="trackingNumber tdc">{{ $fanyi("物流单号") }}</span> -->
      </div>
      <div class="body">
        <div class="bodyOpt" v-if="porder_freight.length == 0">
          <div class="optBody notHaveData">{{ $fanyi('暂无数据') }}</div>
        </div>
        <div class="bodyOpt" v-else>
          <div class="optBody" v-for="(orderItem, orderIndex) in porder_freight" :key="orderIndex"
            @click="openOne(orderItem)">
            <!-- 箱号 -->
            <span class="sn tdc con">
              <span class="box">
                {{ orderItem.number }}
              </span>
            </span>
            <!-- 实际重量 -->
            <span class="weight tdc">{{ orderItem.weight }}</span>
            <!-- 长 -->
            <span class="long tdc">{{ orderItem.length }}</span>
            <!-- 宽 -->
            <span class="wide tdc">{{ orderItem.width }}</span>
            <!-- 高 -->
            <span class="high tdc">{{ orderItem.height }} </span>
            <!-- 体积 -->
            <span class="volume tdc">{{
              $fun.ceil(
                (orderItem.length * orderItem.width * orderItem.height) /
                1000000,
                3
              )
            }}</span>
            <!-- 物流单号 -->
            <!-- <span class="trackingNumber tdc">{{
              $parent.datas.express_no
            }}</span> -->
          </div>
        </div>
      </div>
    </div>
    <danGeShangPingZhuangXiangXinXi></danGeShangPingZhuangXiangXinXi>
  </div>
</template>
<script>
import fanyi from '../../../../../../../utlis/language'
import danGeShangPingZhuangXiangXinXi from './danGeShangPingZhuangXiangXinXi.vue'
export default {
  data() {
    return {
      oneGoodsPackingQuantity: false,
      oneData: {},
    }
  },
  components: {
    danGeShangPingZhuangXiangXinXi,
  },
  computed: {
    porder_freight() {
      if (
        this.$parent.datas.result &&
        this.$parent.datas.result.porder_freight
      ) {
        return this.$parent.datas.result.porder_freight
      }
    },
  },
  created() { },
  methods: {
    openOne(data) {
      this.oneGoodsPackingQuantity = true
      this.oneData = data
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../../../css/mixin.scss';

.logisticsmodebox {

  .huoyunTable {
    width: 1400px;
    margin-top: 30px;
    min-height: 100px;
    background: #FFFFFF;
    padding: 20px;
    border-radius: 20px;

    .head {
      width: 1360px;
      height: 60px;
      background: #F4F4F4;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      span {
        font-weight: 500;
        font-size: 14px;
        color: #121212;
        line-height: 16px;

        text-align: center;

        &:nth-child(1) {
          flex: 0 0 270px;
        }

        &:nth-child(2) {
          flex: 0 0 200px;
        }

        &:nth-child(3) {
          flex: 0 0 200px;
        }

        &:nth-child(4) {
          flex: 0 0 200px;
        }

        &:nth-child(5) {
          flex: 0 0 200px;
        }
      }
    }

    .body {
      .opt {
        height: 60px;
        border-bottom: 1px solid #F4F4F4;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;


        span {
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 16px;

          text-align: center;

          &:nth-child(1) {
            flex: 0 0 270px;
          }

          &:nth-child(2) {
            flex: 0 0 200px;
          }

          &:nth-child(3) {
            flex: 0 0 200px;
          }

          &:nth-child(4) {
            flex: 0 0 200px;
          }

          &:nth-child(5) {
            flex: 0 0 200px;
          }
        }
      }
    }
  }

  .goodsTable {
    width: 1400px;
    min-height: 100px;
    background: #FFFFFF;
    margin-top: 30px;
    border-radius: 20px;
    padding: 20px;

    .head {
      width: 1360px;
      height: 60px;
      background: #F4F4F4;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      span {
        flex: 0 0 200px;
        font-weight: 500;
        font-size: 14px;
        color: #121212;
        display: flex;
        align-items: center;
        justify-content: center;

        &:nth-child(2) {
          flex: 0 0 160px;
        }
      }
    }

    .body {
      .bodyOpt {


        .optBody {
          min-height: 80px;

          border-bottom: 1px solid #F4F4F4;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #fff;


          span {
            flex: 0 0 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            color: #121212;

            &:nth-child(2) {
              flex: 0 0 160px;
            }
          }

          .box {
            width: 60px;
            flex: 0 0 60px;
            font-weight: 500;
            font-size: 14px;
            color: #D12A1D;

            height: 30px;
            border-radius: 10px;
            border: 1px solid #D12A1D;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .notHaveData {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center !important;
        color: #999999;
      }
    }
  }
}
</style>
